import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { InfoIcon, Loader2Icon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { useSession } from '../contexts/SessionContext';
import { CHAMPION_SHIRT_PATH } from '../data/site';
export function Login() {
  const {
    login
  } = useSession();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get('redirect') || '/dashboard';
  const fromShirt = redirect === CHAMPION_SHIRT_PATH;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      setError('Enter your email and password to continue.');
      return;
    }
    setError('');
    setLoading(true);
    window.setTimeout(() => {
      login();
      navigate(redirect, {
        replace: true
      });
    }, 600);
  };
  const field = 'mt-1.5 h-11 w-full rounded border border-gray-300 px-3 text-navy outline-none transition-colors duration-150 focus:border-brand-sky focus:ring-2 focus:ring-brand-sky/30';
  return <PageShell data-id="element-306" data-mp="2wg5b0fbxkfd2">
      <div className="flex justify-center px-6 py-16" data-id="element-307" data-mp="2wflu91y0nx0m">
        <div className="w-full max-w-md" data-id="element-308" data-mp="2we2dla8g7jyb">
          <h1 className="font-condensed text-4xl font-semibold uppercase" data-id="element-309" data-mp="3a70o63tgpimg">Log in</h1>
          {fromShirt && <p className="mt-4 flex gap-3 rounded border border-gold/60 bg-gold/10 p-4 text-[15px] leading-relaxed" data-id="element-310" data-mp="357ffh1ohpvwj">
              <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden data-id="element-311" data-mp="3k57t1oah8a83" />
              Use the member account you registered your player with to shop the League Champion shirt.
            </p>}
          <form onSubmit={handleSubmit} className="mt-6 space-y-5" noValidate data-id="element-312" data-mp="1ptt2545qc4qr">
            <div data-id="element-313" data-mp="1ku6pavttcqih">
              <label htmlFor="email" className="text-sm font-semibold" data-id="element-314" data-mp="1kuouihygef2j">Email</label>
              <input id="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} className={field} data-id="element-315" data-mp="2aic57ufv68ws" />
            </div>
            <div data-id="element-316" data-mp="2jgwhacqx5kc1">
              <label htmlFor="password" className="text-sm font-semibold" data-id="element-317" data-mp="2jgeaim6mrnpv">Password</label>
              <input id="password" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} className={field} data-id="element-318" data-mp="2ogsjc6g231oy" />
            </div>
            {error && <p role="alert" className="text-sm font-medium text-brand-red" data-id="element-319" data-mp="2xgfdq8adb78i">{error}</p>}
            <button type="submit" disabled={loading} className="flex h-11 w-full items-center justify-center gap-2 rounded bg-brand-red font-bold uppercase tracking-wide text-white transition-colors duration-150 hover:bg-brand-red-dark disabled:opacity-70" data-id="element-320" data-mp="327f9393u9h8w">
              {loading && <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden data-id="element-321" data-mp="3h69a6zo12aj2" />}
              {loading ? 'Logging in' : 'Log in'}
            </button>
            <p className="text-center text-sm text-navy/70" data-id="element-322" data-mp="15fhysqxy2xdl">
              New to i9 Sports? <span className="font-semibold text-brand-red" data-id="element-323" data-mp="10hggw9c9943p">Create an account</span>
            </p>
          </form>
        </div>
      </div>
    </PageShell>;
}